// Generated from products/analytics/sdk/attribution.ts; run analytics generate:site-runtime.
const MAX_SEARCH_LENGTH = 8_192;
const MAX_VALUE_LENGTH = 256;

export type AttributionField =
  | "utm_source"
  | "utm_medium"
  | "utm_campaign"
  | "utm_term"
  | "utm_content"
  | "utm_id"
  | "utm_source_platform"
  | "utm_creative_format"
  | "utm_marketing_tactic";

export type PageAttribution = Partial<Record<AttributionField, string>>;

const attributionFields: readonly AttributionField[] = [
  "utm_source",
  "utm_medium",
  "utm_campaign",
  "utm_term",
  "utm_content",
  "utm_id",
  "utm_source_platform",
  "utm_creative_format",
  "utm_marketing_tactic",
];

const controlCharacters = /[\u0000-\u001f\u007f-\u009f]/;

/** Read only the standard UTM fields from the current page's search string. */
export function readPageAttribution(search: string): PageAttribution {
  const result: PageAttribution = {};
  if (typeof search !== "string" || search.length === 0) return result;

  let parameters: URLSearchParams;
  try {
    parameters = new URLSearchParams(search.slice(0, MAX_SEARCH_LENGTH));
  } catch {
    return result;
  }

  for (const field of attributionFields) {
    // URLSearchParams.get returns the first occurrence, making duplicates stable.
    const raw = parameters.get(field);
    if (raw === null || controlCharacters.test(raw)) continue;
    const value = raw.trim();
    if (value.length === 0) continue;
    result[field] = value.slice(0, MAX_VALUE_LENGTH);
  }

  return result;
}
